var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWildcard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.194,
    height: 18.194,
    viewBox: "0 0 18.194 18.194",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.1,0A9.1,9.1,0,1,1,0,9.1,9.1,9.1,0,0,1,9.1,0",
    fill: "#748bf7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.566,4.423H2.759l1.1,4.5h.056L5.1,4.423H6.182l1.181,4.5h.053l1.1-4.5H9.713L7.984,10.546H6.89l-1.225-4.3H5.618l-1.229,4.3h-1.1Z",
    transform: "translate(0.626 1.767)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.855,6.513A1.383,1.383,0,0,0,10.4,5.359c-1,0-1.707.767-1.707,2.148,0,1.407.712,2.15,1.7,2.15a1.387,1.387,0,0,0,1.458-1.121l1.12.006a2.488,2.488,0,0,1-2.593,2.112c-1.614,0-2.8-1.169-2.8-3.146s1.206-3.145,2.8-3.145a2.445,2.445,0,0,1,2.593,2.15Z",
    transform: "translate(3.027 1.743)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWildcard);
export default __webpack_public_path__ + "static/media/Wildcard.ed3030f7a4bec57ec95343bb6c9557df.svg";
export { ForwardRef as ReactComponent };